module.exports = __webpack_public_path__ + "./assets/flags/australia.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/aus@2x.png
// module id = 67
// module chunks = 0 1